import getPurchaseHistory from './getPurchaseHistory'
import getPaymentHistory from './getPaymentHistory'

export const getPurchaseHistoryPromise = getPurchaseHistory;
export const getPaymentHistoryPromise = getPaymentHistory;
